import FormInputTypes from '../components/atoms/formEnums/formInputTypes';


export default {
  title: 'Shared Experiences Config',
  attributeName: 'sharedExperiencesConfig',
  fields: [
    {
      attributeName: 'maxUsersInRoom',
      helpText: 'The maximum number of participants in a shared experiences party.',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Max Users In Room',
      placeholder: 'Input the max users in the room...',
      default: 0,
    },
    {
      attributeName: 'avatarsUpdatePeriod',
      helpText: 'How often to update the P2P packets between members of a shared experiences party (seconds).',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Avatars Update Period',
      placeholder: 'Input a avatars update period...',
      default: 0,
    },
    {
      attributeName: 'maxInactivitySeconds',
      helpText: 'The maximum period of inactivity before considering a user is no longer part of the shared experience part (seconds)',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Max Inactivity Seconds',
      placeholder: 'Input the max time of inactivity (seconds)...',
      default: 0,
    },
    {
      attributeName: 'invitesUpdatePeriod',
      helpText: 'How often to Poll the available invites list (seconds).',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Invites Update Period',
      placeholder: 'Input an invite update period...',
      default: 0,
    },
    {
      attributeName: 'packetMaxAge',
      helpText: 'How long before the avatar P2P packets are considered outdated (seconds).',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Packet Max Age',
      placeholder: 'Input a packet max age...',
      default: 0,
    },
  ],
};
